"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BASE_CLASS_NAME = "mdc-theme";
//# sourceMappingURL=constants.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@react-mdc/theme/lib/constants.js
// module id = ./node_modules/@react-mdc/theme/lib/constants.js
// module chunks = 2